/**
 * excel-address — 엑셀 주소 산수 (기능 함수 — 도메인 무관, 어느 프로젝트에서나 동일).
 * 엑셀 열 문자는 26진법이되 0이 없다: A=1 … Z=26, AA=27.
 */

/** 열 문자 → 열 번호. 'A' → 1 · 'Z' → 26 · 'AH' → 34 */
export function colLetterToNumber(letters: string): number {
  let num = 0;
  for (const ch of letters) num = num * 26 + (ch.charCodeAt(0) - 64);
  return num;
}

/** 열 번호 → 열 문자. 1 → 'A' · 26 → 'Z' · 34 → 'AH' */
export function colNumberToLetter(colNumber: number): string {
  let letters = '';
  let remaining = colNumber;
  while (remaining > 0) {
    const remainder = (remaining - 1) % 26;
    letters = String.fromCharCode(65 + remainder) + letters;
    remaining = Math.floor((remaining - 1) / 26);
  }
  return letters;
}

/** 셀 주소 → [행, 열] 번호. 'AI20' → [20, 35] */
export function parseAddress(address: string): [row: number, col: number] {
  const match = address.match(/^([A-Z]+)(\d+)$/)!;
  return [parseInt(match[2], 10), colLetterToNumber(match[1])];
}
